import { BaseLandscapeService } from '../../base-landscape.service';
import { LandscapeIndicatorResponseDto } from '../dto/response/landscape-indicator-response.dto';
import { LandscapeIndicatorSaveRequestDto } from '../dto/request/landscape-indicator-save-request.dto';
import { LandscapeIndicatorUpdateRequestDto } from '../dto/request/landscape-indicator-update-request.dto';
import { LandscapeIndicatorDetailsResponseDto } from '../dto/response/landscape-indicator-details-response.dto';
import indicatorProjectService from '../../indicator/services/indicator-project.service';
import { LandscapeIndicatorTranslateRequestDto } from '../dto/request/landscape-indicator-translate-request-dto';
import {
  getLanguageKey,
  LocalesLanguagesConstants,
} from '../../../../locales/locales';

class LandscapeIndicatorService extends BaseLandscapeService {
  public async fetchLandscapeIndicators(): Promise<
    LandscapeIndicatorResponseDto[]
  > {
    const response =
      await this.get<LandscapeIndicatorResponseDto[]>(`/compactindicator`);
    return response.data;
  }

  public async fetchLandscapeIndicatorById(
    id: string,
    language: LocalesLanguagesConstants = LocalesLanguagesConstants.en
  ): Promise<LandscapeIndicatorResponseDto> {
    const response = await this.get<LandscapeIndicatorResponseDto>(
      `/compactindicator/${id}`,
      {
        headers: {
          'accept-language': getLanguageKey(language),
        },
      }
    );
    return response.data;
  }

  public async fetchLandscapeIndicatorDetailsByProjectId(
    projectId: string
  ): Promise<LandscapeIndicatorDetailsResponseDto[]> {
    const indicatorProjects =
      await indicatorProjectService.fetchIndicatorProjectsByProjectId(
        projectId
      );
    return await Promise.all(
      indicatorProjects.map(async (i) => {
        return await this.fetchLandscapeIndicatorDetailsById(
          i.compactIndicatorId
        );
      })
    );
  }

  public async fetchLandscapeIndicatorsByLandscapeId(
    landscapeId: string
  ): Promise<LandscapeIndicatorResponseDto[]> {
    const response = await this.get<LandscapeIndicatorResponseDto[]>(
      `/compactindicator/getindicatoridsbycompactid/${landscapeId}`
    );
    return response.data;
  }

  public async fetchLandscapeIndicatorDetailsByLandscapeId(
    landscapeId: string
  ): Promise<LandscapeIndicatorDetailsResponseDto[]> {
    const indicators =
      await this.fetchLandscapeIndicatorsByLandscapeId(landscapeId);
    return await Promise.all(
      indicators.map(async (i) => {
        return await this.fetchLandscapeIndicatorDetailsById(i.id);
      })
    );
  }

  public async fetchLandscapeIndicatorDetailsById(
    id: string
  ): Promise<LandscapeIndicatorDetailsResponseDto> {
    const response = await this.get<LandscapeIndicatorDetailsResponseDto>(
      `/compactindicatordetails/${id}`
    );
    return response.data;
  }

  public async saveLandscapeIndicator(
    saveRequest: LandscapeIndicatorSaveRequestDto
  ): Promise<LandscapeIndicatorResponseDto> {
    const response = await this.post<LandscapeIndicatorResponseDto>(
      `/compactindicator`,
      saveRequest
    );
    return response.data;
  }

  public async updateLandscapeIndicator(
    updateRequest: LandscapeIndicatorUpdateRequestDto
  ): Promise<LandscapeIndicatorResponseDto> {
    const response = await this.put<LandscapeIndicatorResponseDto>(
      `/compactindicator`,
      updateRequest
    );
    return response.data;
  }

  public async deleteLandscapeIndicator(existingId: string): Promise<void> {
    await this.delete<void>(`/compactindicator/${existingId}`);
  }

  public async translateLandscapeIndicator(
    translateRequest: LandscapeIndicatorTranslateRequestDto
  ): Promise<void> {
    const { languageCode, ...compactIndicator } = translateRequest;
    await this.put<void>(
      `/compactindicator/translatecompactindicator/${languageCode}`,
      compactIndicator
    );
  }
}

const landscapeIndicatorService = new LandscapeIndicatorService();
export default landscapeIndicatorService;
